
import { granjaApi } from "../../api";
import Swal from "sweetalert2";






export const startProveedorXID = async(id) => {
    try {
        if( id === 'new') return null;
        const { data } = await granjaApi.get(`/proveedor/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}





export const startListadoProveedores = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await granjaApi.get('/proveedor', { params });
        // useProductosStore.setState({ totalProducto: data.total });
        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingProveedor = async(proveedor) => {
    try {
        if( proveedor.id ){
            await granjaApi.put(`/proveedor/${proveedor.id}`, proveedor);
            Swal.fire('Exitoso', 'Proveedor Actualizado', 'success');
        }else {
            await granjaApi.post('/proveedor/new', proveedor);
            Swal.fire('Exitoso', 'Proveedor Creado', 'success');
        }
        return true;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data.msg, 'error');
        return false;
    }
} 
